<template>
    <div
        :class="[
            isHorizontal ? '' : 'col-lg-4',
        ]"
    >
        <ui-select
            v-if="field.type === 'select'"
            v-model="row[field.name]"
            @input="handleChange"
            :label="field.label"
            :name="`${name}[${index}][${field.name}]`"
            :options="filteredOptions"
            :readonly="readonly"
            :required="field.required"
        />

        <ui-input
            v-else-if="['input', 'text', 'email', 'number'].includes(field.type)"
            v-model="row[field.name]"
            v-bind="field"
            :name="`${name}[${index}][${field.name}]`"
            :required="field.required"
        />
    </div>
</template>

<script>
    import UiInput from '../../ui/input.vue';
    import UiSelect from '../../ui/select.vue';

    export default {
        name: 'DynamicFormField',
        components: {
            UiInput,
            UiSelect,
        },
        props: {
            field: {
                required: true,
                type: Object,
            },
            fields: {
                required: true,
                type: Array,
            },
            row: {
                required: true,
                type: Object,
            },
            isHorizontal: {
                required: true,
                type: Boolean,
            },
            name: {
                required: true,
                type: String,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            index: {
                required: true,
                type: Number,
            },
        },
        computed: {
            filteredOptions() {
                if (this.field.filter) {
                    return this.field.options.filter((option) => (
                        option[this.field.filter] === this.row[this.field.filter]
                        || !option?.[this.field.filter]
                    ));
                }

                return this.field.options;
            },
        },
        methods: {
            handleChange() {
                const affectingFilterField = this.fields.find(({ filter }) => filter === this.field.name);

                if (affectingFilterField) {
                    this.row[affectingFilterField.name] = '';
                }
            },
        },
    };
</script>
